const actions = {
  // Listar Papéis
  listarOrdem: async (context, { per_page, page, numero }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/ordem-de-servico/listagem-simplificada`, {
      params: {
        per_page,
        page,
        numero,
        data_inicial: "01/01/2001",
      },
    });
    return response;
  },
  criarOrdem: async (context, { dados }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/ordem-de-servico`, {
      descricao: dados.descricao,
      alvo: dados.alvo,
      numero: dados.numero,
      data_esperada_termino: dados.data_esperada_termino,
    });
    return response;
  },

  removerOrdem: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/ordem-de-servico/${id}`);
    return response;
  },

  associarOrdem: async (context, { osid, voucher_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `/ordem-de-servico/${osid}/vincular-voucher/${voucher_id}`,
      {
        osid,
        voucher_id,
      }
    );
    return response;
  },

  listarAssociados: async (context, { per_page, page, osid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/ordem-de-servico/${osid}`, {
      params: {
        per_page,
        page,
      },
    });
    return response;
  },
};

export const ordem = {
  namespaced: true,
  actions,
};
